/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    disconnect: {
        from: "IndmerXR",
        success: "You have been successfully disconnected from"
    },
    redirect: {
        label: "You will be redirected to your",
        linkName: "authentication portal"
    }
};